export default "__VITE_ASSET__OqJt8FdB__"